export const WEB3MODAL_PROJECT_ID = import.meta.env.VITE_WEB3MODAL_PROJECT_ID

export const VALIDATORS_API = 'https://rpc.waterfall.network/validator/eth/v1/'
export const VALIDATORS_DEV_API = 'https://rpc.testnet9.waterfall.network/validator/eth/v1/'
export const DEFAULT_UPDATE_INTERVAL = 10_000

export const JWATER_API = 'http://localhost:3000/'

export const WATER_ID = 'water-3'
export const TOKEN_ID = ''

export const WATER_SYMBOL = 'water'
export const JPOOL_TOKEN_SYMBOL = 'jWater'
